export interface Identifiable {
  id: string | number;
}

// NOTE: eslint disable and this note can be removed once we have multiple exports in this file.
// eslint-disable-next-line import/prefer-default-export
export function normalizeById<T extends Identifiable>(
  apiData: T[]
): { [key in string | number]: T } {
  return apiData.reduce(
    (acc, obj) => ({
      ...acc,
      [obj.id]: obj,
    }),
    {}
  );
}

export function getIds<T extends Identifiable>(
  apiData: T[]
): (string | number)[] {
  return apiData.map(obj => obj.id);
}
